import { defineStore } from 'pinia';

const STORAGE_KEY = 'mlm_locale';

const normalizeLocale = (v) => (v === 'en' ? 'en' : 'de');

const detectInitialLocale = () => {
  try {
    const fromStorage = localStorage.getItem(STORAGE_KEY);
    if (fromStorage) return normalizeLocale(fromStorage);
  } catch (e) {
    void e;
  }

  // Browser-Sprache als Default
  const nav = (navigator.language || '').toLowerCase();
  if (nav.startsWith('en')) return 'en';
  return 'de';
};

export const useLocaleStore = defineStore('locale', {
  state: () => ({
    locale: detectInitialLocale()
  }),
  actions: {
    setLocale(next) {
      this.locale = normalizeLocale(next);
      try {
        localStorage.setItem(STORAGE_KEY, this.locale);
      } catch (e) {
        void e;
      }
    },
    toggle() {
      this.setLocale(this.locale === 'de' ? 'en' : 'de');
    }
  }
});
